// Start imports here
import '../components/age-gate/js/age-gate';
import '../components/back-to-top/js/back-to-top';
import '../components/feature-hero-image/js/feature-hero-image';
import '../components/gallery/js/gallery';
import '../components/header/js/header';
import '../components/header/js/header-nav';
import '../components/popup-modal/js/popup-modal';
import '../components/social-embeds/js/instagram';
import '../components/us-content-banner/js/us-content-banner';
import '../components/videos/js/video';
import './video-adblocker';

// Global imports.
import BreakpointWatcher from '../components/ads/js/breakpoint-watcher';
import NextArticlePopup from '../components/next-article-popup/js/next-article-popup';
import PostsBlock from '../components/posts-block/js/posts-block';

// Page template specific imports
import NewsLetterPage from '../components/newsletter/js/newsletter';
import offsetWallpaperForLeaderboard from '../components/ads/js/offset-wallpaper-for-leaderboard';

// Need to export classes so browser can access it
/* eslint-disable import/prefer-default-export */
export { BreakpointWatcher };
export { PostsBlock };

NewsLetterPage();

offsetWallpaperForLeaderboard();

NextArticlePopup();
